import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ObjectResultModel } from '@app/models';
import { EventHubLogListModel, EventHubPaymentModel, EventPaymentResolutionModel } from '../models';

@Injectable()
export class EventHubLogService {
	endpointBase = '/api/event-hub-log';

	constructor(private readonly $http: HttpClient) {}

	getPaymentErrorList(): Observable<EventHubLogListModel[]> {
		return this.$http.get<EventHubLogListModel[]>(`${this.endpointBase}/list`, {
			params: {
				EventCategory: 'payment',
			},
		});
	}

	getPaymentDetail(id: number): Observable<EventHubPaymentModel> {
		return this.$http.get<EventHubPaymentModel>(`${this.endpointBase}/get-detail`, {
			params: {
				Id: id.toString(),
				EventCategory: 'payment',
			},
		});
	}

	getPaymentForResolution(id: number): Observable<any> {
		return this.$http.get<any>(`${this.endpointBase}/get-payment-for-resolution/${id}`);
	}

	resolvePayment(model: EventPaymentResolutionModel): Observable<ObjectResultModel> {
		return this.$http.post<ObjectResultModel>(`${this.endpointBase}/resolve-payment`, model);
	}

	cancelInvalidPayment(id: number): Observable<ObjectResultModel> {
		return this.$http.post<ObjectResultModel>(`${this.endpointBase}/cancel-invalid-payment`, id);
	}
}
